import LockerType from 'src/models/locker/LockerType'
import DurationPeriod from 'src/models/period/DurationPeriod'
import ReservationInfoJson from 'src/models/rental/interfaces/ReservationInfoJson'
import Location from 'src/models/event/Location'
import { DateTime } from 'luxon'

export default class ReservationInfo {
  token: string
  code: string
  status: string
  lockerType: LockerType
  location: Location
  durationPeriod: DurationPeriod
  pickupAllowedStarting: DateTime
  unitName: null | string
  orderToken: null | string
  deeplink: null | string

  constructor(
    token: string,
    code: string,
    status: string,
    lockerType: LockerType,
    location: Location,
    durationPeriod: DurationPeriod,
    pickupAllowedStarting: DateTime,
    unitName: null | string,
    orderToken: null | string,
    deeplink: null | string,
  ) {
    this.token = token
    this.code = code
    this.status = status
    this.lockerType = lockerType
    this.location = location
    this.durationPeriod = durationPeriod
    this.pickupAllowedStarting = pickupAllowedStarting
    this.unitName = unitName
    this.orderToken = orderToken
    this.deeplink = deeplink
  }

  static fromJson(data: ReservationInfoJson, token: string) {
    return new this(
      token,
      data.code,
      data.status,
      LockerType.fromJson(data.lockerType),
      Location.fromJson(data.location),
      DurationPeriod.fromJson(data.durationPeriod),
      data.pickupAllowedStarting
        ? DateTime.fromISO(data.pickupAllowedStarting.date, {
            zone: data.pickupAllowedStarting.timezone,
          })
        : DateTime.now().minus({ days: 1 }), // todo: fallback can be removed in next release. ReservationInfoJson:pickupAllowedStarting, nullability can be removed
      data.unitName,
      data.orderToken,
      data.deeplink ?? null, // absent on records cached before deep links reached the pickup payload
    )
  }

  toJson(): ReservationInfoJson {
    return {
      code: this.code,
      status: this.status,
      lockerType: this.lockerType.toJson(),
      location: this.location.toJson(),
      durationPeriod: this.durationPeriod.toJson(),
      pickupAllowedStarting: {
        date: this.pickupAllowedStarting.toISO() ?? '',
        timezone: this.pickupAllowedStarting.zoneName ?? 'UTC',
      },
      unitName: this.unitName,
      orderToken: this.orderToken,
      deeplink: this.deeplink,
    }
  }
}
